export default class TimerClock {

    private timeout: number|undefined;
    private readonly duration: number;
    private readonly onTimeout: () => void;

    /**
     * Creates a timer
     * @param duration  Duration in seconds
     * @param onTimeout What to do when timer ends
     */
    constructor(duration: number, onTimeout: () => void) {
        this.duration = duration;
        this.onTimeout = onTimeout;
    }

    public start() {
        this.timeout = window.setTimeout(this.onTimeout, this.duration * 1000);
    }

    public stop() {
        clearTimeout(this.timeout);
    }

}